import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { NotificationType } from "../../constants/appConstants";
import { useNavigate } from "react-router-dom";

const routingPath = {
  [NotificationType.GTPInvitation]: "/gtp",
  [NotificationType.BookingRejected]: "/sessions?tab=cancelled",
  [NotificationType.BookingAccepted]: "/sessions",
  [NotificationType.RegularSession]: "/notification?tab=regular_session",
  [NotificationType.GroupSession]: "/notification?tab=group_session",
  [NotificationType.GTPMemberRemoved]: "/gtp",
  [NotificationType.CloverTicketPurchased]: "/tickets",
  [NotificationType.StageCardAccepted]: "/sessions/stagecard",
  [NotificationType.CoffeeCallRejected]: "/coffeecall?tab=rejected",
  [NotificationType.CardReviewCreated]: "/talent/profile?tab=reviews",
  [NotificationType.AceCardPurchased]: "/talent/profile",
  [NotificationType.FanCardPurchased]: "/talent/profile",
  [NotificationType.PremiumContentPurchased]: "/talent/profile",
  [NotificationType.BusinessTalentInvite]: "/business",
  [NotificationType.BusinessTalentInviteAccepted]: "/talent-pool",
  [NotificationType.BusinessTalentInviteRejected]: "/talent-pool",
  [NotificationType.BookingInvite]: "/notification?tab=Bookings",
  [NotificationType.InstantSessionRequested]: "/instant-cards/bookings",
  [NotificationType.InstantSessionResponded]: "/instant-cards/bookings",
  [NotificationType.InstantSessionStarted]: "/instant-cards/bookings",
  [NotificationType.StageCard]: "/sessions/stagecard",
  [NotificationType.FlashCardStarted]: "/flash-bookings",
  [NotificationType.FlashCardBooking]: "/flash-cards/bookings",
  [NotificationType.FlashCardBookingRefund]: "/flash-cards/bookings",
  [NotificationType.StaiSessionStarted]: "/stai",
  [NotificationType.StaiSessionEnded]: "/stai",
  [NotificationType.GiftCardRequestCreated]: "/gift-cards",
  [NotificationType.GiftCardRequestAccepted]: "/gift-cards",
  [NotificationType.GiftCardRequestRejected]: "/gift-cards",
  [NotificationType.GiftCardRequestCompleted]: "/gift-cards",
  [NotificationType.GiftCardSent]: "/gifts-received",
};

const DefaultNotification = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();

  const navigate = useNavigate();

  const handleClick = () => {
    const routePath =
      routingPath[notification.notification_type as keyof typeof routingPath];
    if (routePath) {
      navigate(routePath);
    } else {
      console.warn(
        "No route path found for notification type:",
        notification.notification_type,
      );
    }
  };
  return (
    <Box onClick={handleClick} sx={wrapperStyles(darkMode)}>
      {/* <Box sx={iconBoxStyles(darkMode)}>
        <Info sx={{ color: "#6366f1", fontSize: 24 }} />
      </Box> */}
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {notification?.title ?? "Notification"}
        </Typography>
        <Typography
          sx={{
            color: darkMode ? "#e5e7eb" : "#374151",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#d1d5db" : "#4b5563",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default DefaultNotification;
